import { createFileRoute } from '@tanstack/react-router';
import UnsyncedPostsView from '../admin/loadboards/unsynced/unsynced-posts-view';
export const Route = createFileRoute('/admin/loadboards/unsynced')({
  component: UnsyncedPostsView,
});
